// A one-time link that sets a password and logs the person in: an invitation to the team (platform П8) or a reset (decision 030).

import { useState } from 'react';
import { Button, Input, Field } from '../ui/primitives.tsx';
import s from './shell.module.css';

export function AcceptInvite({ userId, token, onDone, reset = false }: { userId: string; token: string; onDone: () => void; reset?: boolean }) {
  const [password, setPassword] = useState('');
  const [again, setAgain] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== again) { setError('Пароли не совпадают'); return; }
    setBusy(true);
    setError(null);
    try {
      const r = await fetch(reset ? '/api/auth/reset' : '/api/auth/invite', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ id: userId, token, password }) });
      if (r.ok) { history.replaceState(null, '', '/'); onDone(); }
      else setError(((await r.json()) as { error?: { message?: string } }).error?.message ?? 'Не удалось задать пароль');
    } catch {
      setError('Сервер недоступен. Проверьте соединение.');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className={s.login}>
      <form className={s.loginCard} onSubmit={submit}>
        <div className={s.logo}>CD</div>
        <h1 className={s.loginTitle}>{reset ? 'Новый пароль' : 'Вас пригласили в команду'}</h1>
        <p className={s.loginHint}>{reset ? 'Задайте новый пароль. Все прежние входы будут завершены.' : 'Задайте пароль — дальше входите с ним и своим email.'}</p>
        <Field className={s.big} label="Пароль"><Input type="password" autoComplete="new-password" autoFocus minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} required /></Field>
        <Field className={s.big} label="Ещё раз"><Input type="password" autoComplete="new-password" minLength={8} value={again} onChange={(e) => setAgain(e.target.value)} required /></Field>
        {error && <div className={s.loginError} role="alert">{error}</div>}
        <Button type="submit" variant="primary" size="lg" disabled={busy}>Задать пароль и войти</Button>
      </form>
    </div>
  );
}
